<script setup>
import { ref } from 'vue'
import { useNotification } from "@kyvg/vue3-notification";
import MultiviewService from '@/services/MultiviewService';
import AddPlayoutErrorAlert from '@/components/TVPlayout/AddPlayoutErrorAlert.vue'
import { useStore } from 'vuex'
import FormButton from '../Atoms/FormButton.vue'
import FloatingInput from '../ui/FloatingInput.vue'
import Sidebar from '../modals/Sidebar'
import MultiviewTile from '@/components/Multiview/MultiviewTile.vue'
import { track, EVENTS } from '@/lib/tracking'

const store = useStore()
const { notify } = useNotification()

const sidebar = ref()
const error = ref(null)
const selectedTile = ref(2)

const playout = ref({
	name: '',
})

const emit = defineEmits(['multiview-added'])

const toggleSidebar = () => sidebar.value.toggleSidebar()

const onReset = (() => {
	playout.value = { name: '' }
	error.value = null
})

const createMultiview = (async () => {
	try {
		store.dispatch('Ui/setLoadingStatus', true)
		const newPayout = await MultiviewService.createMultiview(
			playout.value.name,
			selectedTile.value,
		);
		track(EVENTS.MULTIVIEW_CREATED, { multiviewId: newPayout?._id, layout: selectedTile.value })
		// The parent keeps the loading screen up until the new multiview's page opens.
		emit('multiview-added', newPayout)
		notify({ group: 'success', text: 'Multiview created.' })
		sidebar.value.closeSidebar()
	} catch (err) {
		console.log(err);
		error.value = err.message
		store.dispatch('Ui/setLoadingStatus', false)
	}
})

const tileSelected = ((tileNum) => {
    selectedTile.value = tileNum
})

defineExpose({ toggleSidebar })
</script>

<template>
	<Sidebar
		ref="sidebar"
		:stage="1"
		title="New Multiview"
		width="md:w-[420px]"
		height="h-auto md:h-[540px]"
		stage-one-custom-class="max-md:!mt-0 max-md:pb-4"
		@closed="onReset"
	>
		<template v-slot:stage-one>
			<div class="px-4 h-full">
				<h3 class="mb-2 mt-3 hidden text-lg font-medium md:block">New Multiview</h3>
				<AddPlayoutErrorAlert :error="error" v-if="error" />
				<div class="mb-3 max-md:mt-3">
					<FloatingInput id="multiview-name" label="Multiview name" surface="2" dense v-model="playout.name" />
				</div>
				<div class="mb-3">
					<label class="text-dark-9 text-s-ss">Layout</label>
					<div class="flex items-center justify-between">
						<MultiviewTile 
							v-for="(item, index) in [2, 4, 6]" 
							:tiles="item" 
							:key="index" 
							:selected="item == selectedTile"
							@tile-selected="tileSelected"
						/>
					</div>
				</div>
				<div class="text-center">
					<FormButton :disabled="playout.name.length === 0" @click="createMultiview" type="primary" size="md"
						class="w-full mt-4 justify-center">
						Create
					</FormButton>
					<FormButton type="secondary" size="md" class="w-full mb-3 mt-2 justify-center"
						@click="toggleSidebar">
						Cancel
					</FormButton>
				</div>
			</div>
		</template>
	</Sidebar>
</template>
